import React, { useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Typography, Card, CardContent, Grid } from '@mui/material';
import { AppContext } from '../context/AppContext';
import { getAgeGroup, meetsStandard } from '../utils/dataUtils';

const SwimmerDetail = () => {
  const { swimmerName } = useParams();
  const navigate = useNavigate();
  const { swimmers, standards, standard } = useContext(AppContext);
  const swimmer = swimmers[decodeURIComponent(swimmerName)];

  if (!swimmer) return <Typography>Swimmer not found</Typography>;

  const { info, events } = swimmer;
  const ageGroup = getAgeGroup(info.Age);
  const standardKey = standard === 'Junior Mets' ? 'juniorMets' : 'seniorMets';
  const relevantStandards = standard === 'None' ? [] : standards[standardKey].filter(
    (s) => s.Gender === info.Gender && (standard === 'Senior Mets' ? s['Age Group'] === 'Open' : s['Age Group'] === ageGroup)
  );

  const filteredEvents = standard === 'None'
    ? events
    : events.filter((event) =>
        relevantStandards.some(
          (std) => std.Event === event.Event && meetsStandard(event.Best_Time, std['Qualifying Time'])
        )
      );

  return (
    <Container>
      <Typography variant="h1">{info.Full_Name}</Typography>
      <Typography variant="h2">Personal Information</Typography>
      <Typography>First Name: {info.First_Name}</Typography>
      <Typography>Last Name: {info.Last_Name}</Typography>
      <Typography>Gender: {info.Gender}</Typography>
      <Typography>Age: {info.Age}</Typography>
      <Typography variant="h2" sx={{ mt: 2 }}>
        {standard === 'None' ? 'Events' : `Qualifying Events (${standard.toUpperCase()})`}
      </Typography>
      <Grid container spacing={2}>
        {filteredEvents.map((event) => {
          const qualifyingTime = standard === 'None'
            ? null
            : relevantStandards.find((std) => std.Event === event.Event)?.['Qualifying Time'];
          return (
            <Grid item xs={12} sm={6} key={event.Event}>
              <Card
                onClick={() => navigate(`/swimmer/${encodeURIComponent(swimmerName)}/event/${encodeURIComponent(event.Event)}`)}
                sx={{ cursor: 'pointer', '&:hover': { boxShadow: 6 } }}
              >
                <CardContent>
                  <Typography variant="h2">{event.Event}</Typography>
                  {qualifyingTime && (
                    <Typography>Qualifying Time: {qualifyingTime}</Typography>
                  )}
                  <Typography>Best Time: {event.Best_Time}</Typography>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
};

export default SwimmerDetail;